const firebaseConfig = {
    apiKey: "AIzaSyAzTlzIp_L3ielUnkXmqOA830vMIMFldgw",
    authDomain: "travelco-7f9ff.firebaseapp.com",
    projectId: "travelco-7f9ff",
    storageBucket: "travelco-7f9ff.appspot.com",
    messagingSenderId: "751460825745",
    appId: "1:751460825745:web:86ff530e7b256ab0741d30",
    measurementId: "G-PBTVD6XVMN"
  };

  export default firebaseConfig;